var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoldMedal = function SvgGoldMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 18c0 1.222-1.093 2.251-1.452 3.345-.359 1.093-.114 2.588-.815 3.537-.702.949-2.202 1.158-3.083 1.865-.881.708-1.631 2.026-2.773 2.396-1.142.37-2.43-.338-3.67-.338-1.24 0-2.561.692-3.67.338-1.11-.354-1.811-1.72-2.774-2.396-.962-.675-2.463-.916-3.164-1.865-.702-.949-.44-2.412-.816-3.538C7.908 20.22 6.75 19.223 6.75 18s1.093-2.251 1.452-3.345c.359-1.093.114-2.588.815-3.537.702-.949 2.202-1.158 3.165-1.865.962-.708 1.55-2.026 2.773-2.396 1.223-.37 2.43.338 3.67.338 1.24 0 2.561-.692 3.67-.338 1.11.354 1.81 1.72 2.855 2.396 1.044.675 2.463.916 3.164 1.865.702.949.44 2.412.816 3.537.375 1.126 1.37 2.123 1.37 3.345Z",
    stroke: "#5D5BEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13 17.25 4.219 4.5 7.031-7.5",
    stroke: "#F26722",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgGoldMedal;